export default __webpack_public_path__ + "static/media/whatsapp.6ad6c46b.svg";